// Funds whose investments + reportings are hidden from the platform.
// Reportings for these are sent manually via email (watermarked separately).
export const HIDDEN_FUND_IDS: ReadonlyArray<string> = [
  "9dffccd2-ac15-4083-8788-5e5e8e2da9ff", // Endurance Token
  "b5cfd00f-1d09-4d56-acd3-1d2126d9db0c", // Titan Tech Token
];

export function isHiddenFund(fundId: string | null | undefined): boolean {
  return fundId != null && HIDDEN_FUND_IDS.includes(fundId);
}
